import axios from 'axios'

// 连接测试环境或生产环境
const isTest = false
function extensionPath() {
  return isTest ? 'test/' : ''
}

/**
 * 获取自定义产品列表
 */
export const getProductList = async () => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}manager/product-info/query`, {})
  return data
}

/**
 * 新增自定义产品
 */
export const addProduct = async (name, describe, pollingTime = 600) => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}manager/product-info`, {
    name,
    describe,
    pollingTime
  })
  return data
}

/**
 * 编辑自定义产品
 */
export const editProduct = async (id, {name, describe, pollingTime = 600 }) => {
  const { data } = await axios.put(`/jvcom/dtu/${extensionPath()}manager/product-info`, {
    name,
    describe,
    pollingTime,
    id
  })
  return data
}

/**
 * 删除自定义产品
 */
export const removeProduct = async (id) => {
  const { data } = await axios.delete(`/jvcom/dtu/${extensionPath()}manager/product-info`, {
    data: [id]
  })
  return data
}

/**
 * 查询协议列表
 */
export const protocolList = async () => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}accessor/protocol-info/query`, {})
  return data
}

/**
 * 新增自定义协议
 */
export const addProtocol = async (name, describe, addressUp, addressDown, protocolType = 'MODBUS') => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}accessor/protocol-info`, {
    name,
    describe,
    addressUp,
    addressDown,
    protocolType
  })
  return data
}

/**
 * 修改自定义协议
 */
export const editProtocol = async (id, {name, describe, addressUp, addressDown, protocolType = 'MODBUS'}) => {
  const { data } = await axios.put(`/jvcom/dtu/${extensionPath()}accessor/protocol-info`, {
    id,
    name,
    describe,
    protocolType,
    addressUp,
    addressDown
  })
  return data
}

/**
 * 删除自定义协议
 */
export const removeProtocol = async (id) => {
  const { data } = await axios.delete(`/jvcom/dtu/${extensionPath()}accessor/protocol-info`, {
    data: [id]
  })
  return data
}

/**
 * 新增产品和协议关联关系
 */
export const productLinkProtocol = async (productId, protocolId) => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}accessor/product-protocol-rel`, {
    productId,
    protocolId
  })
  return data
}

/**
 * 根据产品id查协议信息列表
 */
export const getProtocolByProduct = async (productId) => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}accessor/product-protocol-rel/find-protocol-by-product-id/${productId}`)
  return data
}

/**
 * 根据ID查询自定义协议
 */
export const getProtocol = async (id) => {
  const { data } = await axios.get(`/jvcom/dtu/${extensionPath()}accessor/protocol-info/${id}`)
  return data
}

/**
 * 获取自定义协议分组（一个分组对应一条指令）
 */
export const getProtocolGroup = async (protocolId) => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}accessor/data-point-group/query`, {
    protocolId
  })
  return data
}

/**
 * 新增自定义协议分组（一个分组对应一条指令）
 */
export const addProtocolGroup = async (name, describe, protocolId, funcCode, preprocessFuncUp, preprocessFuncDown, isPolling) => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}accessor/data-point-group`, {
    name,
    describe,
    protocolId,
    funcCode,
    preprocessFuncUp,
    preprocessFuncDown,
    polling: isPolling
  })
  return data
}
/**
 * 编辑自定义协议分组（一个分组对应一条指令）
 */
export const editProtocolGroup = async (groupId, name, describe, funcCode, preprocessFuncUp, preprocessFuncDown, isPolling) => {
  const { data } = await axios.put(`/jvcom/dtu/${extensionPath()}accessor/data-point-group`, {
    name,
    describe,
    id: groupId,
    funcCode,
    preprocessFuncUp,
    preprocessFuncDown,
    polling: isPolling
  })
  return data
}
/**
 * 删除自定义协议分组（一个分组对应一条指令）
 */
export const deleteProtocolGroup = async (groupId) => {
  const { data } = await axios.delete(`/jvcom/dtu/${extensionPath()}accessor/data-point-group`, {
    data: [groupId]
  })
  return data
}
/**
 * 根据分组ID自定义协议分组数据点
 */
export const getProtocolGroupPoint = async (protocolId, groupId) => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}accessor/data-point/query`, {
    protocolId,
    groupId
  })
  return data
}
/**
 * 新增/编辑自定义协议分组数据点
 */
export const addOrUpdateProtocolGroupPoint = async (options) => {
  let method = options.id ? 'put' : 'post'
  let params = {
    name: options.name, // 数据点名称
    describe: options.describe, // 描述，备注
    protocolId: options.protocolId, // 协议ID
    groupId: options.groupId, // 协议分组
    funcType: options.funcType, // 功能码区分：COIL-线圈，REGISTER-寄存器
    address: options.address, // 寄存器地址-MODBUS
    key: options.key, // 寄存器地址-SCRIPT
    dataConversionType: options.dataConversionType, // 数据转换类型：ENUMS, INT, FLOAT
    
    unit: options.unit, // 单位
    decimalPlaces: options.decimalPlaces, // 保留小数位
    coefficient: options.coefficient, // 系数
    offset: options.offset, // 偏移量

    readWriteType: options.readWriteType, // 读写类型: READ, WRITE, READ_WRITE

    byteOrder: options.byteOrder, // 字节序: AB, BA, AB_CD, DC_BA, BA_DC, CD_AB


    symbol: options.symbol, // 数据符号类型，true-有符号，false-无符号
    dataType: options.dataType, // 数据类型(寄存器数量): TYPE_8, TYPE_16, TYPE_32

    bitAddress: options.bitAddress, // 比特位起始地位0～31
    bitLength: options.bitLength, // 比特位长度

    enumMap: options.enumMap, // 枚举配置

    orderNumber: options.orderNumber, // 显示顺序
    isShow: options.isShow, // 是否显示
  }
  params.id = options.id || null
  const { data } = await axios[method](`/jvcom/dtu/${extensionPath()}accessor/data-point`, params)
  return data
}
/**
 * 删除自定义协议分组数据点（一个分组对应一条指令）
 */
export const deleteProtocolGroupPoint = async (pointId) => {
  const { data } = await axios.delete(`/jvcom/dtu/${extensionPath()}accessor/data-point`, {
    data: [pointId]
  })
  return data
}
/**
 * 查询当前数据记录
 */
export const getDeviceCurrentRecord = async (options) => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}accessor/device-point-status-record/current-data`, {
    snHex: options.snHex,
    protocolId: options.protocolId,
    groupId: options.groupId,
  })
  return data
}

/**
 * 调试自定义函数
 */
export const deviceAccessorEvalJs = async (script, argument, functionName) => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}device-accessor/eval-js`, {
    script,
    argument,
    functionName
  })
  return data
}
/**
 * 下发协议
 */
export const downCommand = async () => {
  const { data } = await axios.post(`/jvcom/dtu/${extensionPath()}accessor/processor-protocol/down-protocol-dtu`, {
    sn: '55000001',
    readWriteType: 'READ',
    command: 16
  })
  return data
}
